import { INFORMATIVE_ERRORS, SNACKBAR_ERRORS, ALERT_ERRORS } from './checkRequests.constants'
import { NAVIGATION_TYPES } from 'utils/constants/constants'

export const isInformative = (config) => {
  if (!config || !config?.url) return false

  const b = INFORMATIVE_ERRORS.some((e) => config.url.includes(e.url) && config.method === e.method)
  return b
}

export const isAlert = (config) => {
  if (!config || !config?.url) return false

  const b = ALERT_ERRORS.some((e) => config.url.includes(e.url) && config.method === e.method)
  return b
}

export const isBlocking = (error) => {
  return (
    error?.status === 500 ||
    (error?.status === 403 && error?.data?.code === 'UserHasNotBookException') ||
    (error?.status === 404 && error?.data?.code === 'BookNotFoundException')
  )
}

export const isSnackbar = (config) => {
  if (!config || !config?.url) return false

  const b = SNACKBAR_ERRORS.some((e) => config.url.includes(e.url) && config.method === e.method)
  return b
}

export const mustShowNav2Error = (navigationType) => {
  return navigationType === NAVIGATION_TYPES.nav2023 || navigationType === NAVIGATION_TYPES.open20
}

export const redirectIfUnauthorized = (error) => {
  if (error?.status === 403) {
    window.location = window.viewer.edubookUrl
  }
}

export const redirectIfSessionOver = (error) => {
  if (error?.status === 423) {
    const language = localStorage.getItem('userLanguage') ?? 'es'
    window.location = `${window.viewer.edubookUrl}sessionError?lang=${language}`
  }
}
